;(function() {
  'use strict'

  Factory.$inject = ["$q", "$log", "Pipes", "Logic", "numericService", "titleSelector", "glSurveyUtils", "glEmail", "Lender", "Randomizer", "Timer", "locationSetService"];
  angular.module('app.core').factory('ResponderQuestion', Factory)

  /* @ngInject */
  function Factory(
    $q,
    $log,
    Pipes,
    Logic,
    numericService,
    titleSelector,
    glSurveyUtils,
    glEmail,
    Lender,
    Randomizer,
    Timer,
    locationSetService
  ) {
    var NUMERIC_REGEX = /^\d+(\.\d+)?$/
    var log = $log.create('ResponderQuestion')

    var AutocompleteKeyTypes = {
      location: 'location',
      sex: 'sex',
      age_range: 'agerange',
      age_year_of_birth: 'numeric',
    }

    var Defaults = {
      submitAsDimension: false,
    }

    var Types = {
      CHOICE: 'choice',
      RANK: 'rank',
      FOLLOWUP: 'followup',
      IMAGE: 'image',
      MOOD: 'mood',
      NPS: 'nps',
      SCAN: 'scan',
      PLACE: 'placesnearme',
      TEXT: 'singletext',
      TEXTAREA: 'text',
      SCALE: 'scale',
      LOCATION: 'location',
      RATING: 'rating',
      SEX: 'sex',
      AGE_RANGE: 'agerange',
      NUMERIC: 'numeric',
      MATRIX: 'matrix',
      CONSTANT_SUM: 'constantsum',
      SCORE: 'score',
      HIDDEN_VARIABLES: 'hiddenvariables',
    }

    var MoodInfo = [
      {
        label: 'Very Angry',
        value: '1',
        iconClass: 'gi-mood-6',
        colorClass: 'mood-6',
      },
      {
        label: 'Angry',
        value: '2',
        iconClass: 'gi-mood-5',
        colorClass: 'mood-5',
      },
      {
        label: 'Meh',
        value: '3',
        iconClass: 'gi-mood-4',
        colorClass: 'mood-4',
      },
      {
        label: 'Neutral',
        value: '4',
        iconClass: 'gi-mood-3',
        colorClass: 'mood-3',
      },
      {
        label: 'Happy',
        value: '5',
        iconClass: 'gi-mood-2',
        colorClass: 'mood-2',
      },
      {
        label: 'Very Happy',
        value: '6',
        iconClass: 'gi-mood-1',
        colorClass: 'mood-1',
      },
    ]

    var MatrixDisplayTypes = {
      DEFAULT: 'DEFAULT',
      DROPDOWN: 'DROPDOWN',
      SCALE: 'SCALE',
      CAROUSEL: 'CAROUSEL',
      DND: 'DND',
    }

    var LocationTypes = {
      DEFAULT: 'DEFAULT',
      PLACES: 'PLACES',
    }

    /**
     * @class ResponderQuestion
     * @desc instantiates a new responder-question for a survey
     * @param {Object} data - The survey question data
     */
    function ResponderQuestion(data) {
      this.timer = new Timer()
      _.defaultsDeep(this, data, _.cloneDeep(Defaults))
    }

    ResponderQuestion.prototype.Defaults = ResponderQuestion.Defaults = Defaults
    ResponderQuestion.prototype.Types = ResponderQuestion.Types = Types
    ResponderQuestion.prototype.MoodInfo = ResponderQuestion.MoodInfo = MoodInfo
    ResponderQuestion.prototype.MatrixDisplayTypes = ResponderQuestion.MatrixDisplayTypes = MatrixDisplayTypes
    ResponderQuestion.prototype.LocationTypes = ResponderQuestion.LocationTypes = LocationTypes

    ResponderQuestion.prototype.toggleSelected = function(value, statement) {
      switch (this.type) {
        // single selection
        case Types.MOOD:
        case Types.NPS:
        case Types.FOLLOWUP:
        case Types.SCALE:
        case Types.RATING:
        case Types.SEX:
        case Types.AGE_RANGE:
        case Types.NUMERIC:
        case Types.SCORE:
          return this.toggleSingle_(value, statement)

        // multi selection
        case Types.RANK:
          return this.toggleMulti_(value, statement)

        // variable selection
        case Types.PLACE:
        case Types.CHOICE:
        case Types.MATRIX:
          return this.maxSelections === 1
            ? this.toggleSingle_(value, statement)
            : this.toggleMulti_(value, statement)

        // unsupported
        case Types.TEXT:
        case Types.TEXTAREA:
        case Types.IMAGE:
        case Types.LOCATION:
          return
      }
    }

    ResponderQuestion.prototype.ensureUniqueSelection = function(
      value,
      statement
    ) {
      // deselect choice(value) from other statements
      _.each(this.statementAnswers, function(answers, key) {
        if (key === statement.id) return true // continue
        if (_.includes(answers, value)) {
          _.remove(answers, value)
        }
      })
    }

    ResponderQuestion.prototype.toggleSingle_ = function(value, statement) {
      var selected = this.getSelected(statement)
      var shouldAdd = !_.includes(selected, value)
      if (shouldAdd) {
        _.remove(selected)
        selected.push(value)

        if (this.matrixUniqueSelection) {
          this.ensureUniqueSelection(value, statement)
        }
      } else {
        _.remove(selected, value)
      }
    }

    ResponderQuestion.prototype.toggleMulti_ = function(value, statement) {
      var selected = this.getSelected(statement)
      var shouldAdd = !_.includes(selected, value)
      if (shouldAdd && this.canSelectMore(statement)) {
        if (value.data && value.data.isExclusive) {
          _.remove(selected)
        }
        value.rank = this.getNextRank()
        selected.push(value)

        if (this.matrixUniqueSelection) {
          this.ensureUniqueSelection(value, statement)
        }
      } else {
        _.remove(selected, value)
        this.recalculateRanks()
      }
    }

    ResponderQuestion.prototype.setSelected = function(value, statement) {
      var selected = this.getSelected(statement)
      _.remove(selected)
      if (_.isArray(value)) {
        _.each(value, function(item) {
          selected.push(item)
        })
      } else if (value) {
        selected.push(value)
      }

      if (value && this.matrixUniqueSelection) {
        this.ensureUniqueSelection(value, statement)
      }
    }

    ResponderQuestion.prototype.getNextRank = function() {
      var self = this
      var nextRank
      _.each(_.sortBy(self.selected, 'rank'), function(item, index) {
        if (item.rank !== index) {
          nextRank = index
          return false
        }
      })
      return _.isNumber(nextRank) ? nextRank : self.selected.length
    }

    ResponderQuestion.prototype.filterChoicesOrStatementsByLender = function(
      lender,
      choicesOrStatements
    ) {
      // filter choicesOrStatements (choices OR statements) based on the lender type and lender reducer

      // remove exclusions
      choicesOrStatements = _.filter(choicesOrStatements, function(item) {
        return !_.includes(lender.exclusionIds, item.id)
      })

      // if there's no selected reducer then no more filtering is required (just exclusions are removed)
      if (!lender.reducer) {
        return choicesOrStatements
      }

      var lenderQuestion = lender.loopKey
        ? this.responder.getQuestionByIdAndLoopKey(lender.id, lender.loopKey)
        : this.responder.getQuestionById(lender.id)
      var result

      if (lenderQuestion.isUsedAsMatrix() && lender.targetsStatements()) {
        var lenderVisibleStatements = lenderQuestion.getVisibleStatements()
        // it's matrix type and statements target
        // because the target is statements, the choices are copied from a statement
        // so when we loop it, each item is technically a statement
        result = choicesOrStatements.filter(function(statement) {
          if (!statement.data.isBorrowed) {
            return true // always keep local choices
          }
          if (statement.data.isHeading) {
            return true // always keep headings
          }

          // when using "only show statements displayed to respondent..."
          // show statements that is visible on lender question
          if (lender.reducer === Lender.Reducer.DISPLAYED) {
            return !!_.find(lenderVisibleStatements, { id: statement.id })
          }

          // when using "only show statements not displayed to respondent..."
          // show statements that is NOT visible on lender question
          if (lender.reducer === Lender.Reducer.NOT_DISPLAYED) {
            return !_.find(lenderVisibleStatements, { id: statement.id })
          }

          // when using "only show statements where respondent didn't select..."
          // we should exclude statements that have no selections since the
          // respondent may not have even seen those options.
          if (!lenderQuestion.getSelected(statement).length) return false

          var isSelected = lenderQuestion.isSelected(function(lenderChoice) {
            return lender.choiceIds.indexOf(lenderChoice.id) !== -1
          }, statement)

          switch (lender.reducer) {
            case Lender.Reducer.SELECTED:
              return isSelected
            case Lender.Reducer.NOT_SELECTED:
              return !isSelected
          }
        })
        return result
      }

      var lenderVisibleChoices = lenderQuestion.getVisibleChoices()
      result = choicesOrStatements.filter(function(choice) {
        if (!choice.data.isBorrowed) {
          return true // always keep local choices
        }
        if (choice.data.isHeading) {
          return true // always keep headings
        }

        // when using "only show choices displayed to respondent..."
        // show choices that are visible on lender question
        if (lender.reducer === Lender.Reducer.DISPLAYED) {
          return !!_.find(lenderVisibleChoices, { id: choice.id })
        }

        // when using "only show choices not displayed to respondent..."
        // show choices that is NOT visible on lender question
        if (lender.reducer === Lender.Reducer.NOT_DISPLAYED) {
          return !_.find(lenderVisibleChoices, { id: choice.id })
        }

        var isSelected

        if (lenderQuestion.isUsedAsMatrix() && lender.targetsChoices()) {
          var statementIds = _.filter(lender.statementIds, function(
            statementId
          ) {
            return lenderQuestion.getSelected({ id: statementId }).length > 0
          })

          if (!statementIds.length) return false // no statements? no selections!

          isSelected = _.some(statementIds, function(statementId) {
            return lenderQuestion.isSelected(
              function(lenderChoice) {
                return lenderChoice.id === choice.id
              },
              { id: statementId }
            )
          })
        } else {
          isSelected = lenderQuestion.isSelected(function(lenderChoice) {
            return lenderChoice.id === choice.id
          })
        }

        switch (lender.reducer) {
          case Lender.Reducer.SELECTED:
            return isSelected
          case Lender.Reducer.NOT_SELECTED:
            return !isSelected
        }
      })
      return result
    }

    function filterChoicesOrStatementsBySampling(
      choicesOrStatements,
      samplingEnabled,
      samplingAmount,
      hiddenIds,
      prevPreSampledIds
    ) {
      if (!samplingEnabled) {
        return choicesOrStatements.slice()
      }

      // we only sample from choices that are not headings
      var nonHeadings = choicesOrStatements.filter(function(item) {
        return !item.data.isHeading
      })

      // compare current pre-sampled ids with previous pre-sampled ids
      // to determine if the visible choices or statements has been modified
      // and should get new sample
      var currentPreSampledIds = _.map(nonHeadings, 'id')
      var shouldResample = !_.isEqual(
        currentPreSampledIds.sort(),
        prevPreSampledIds.sort()
      )
      if (shouldResample) {
        _.remove(prevPreSampledIds) // clear array
        _.each(nonHeadings, function(item) {
          prevPreSampledIds.push(item.id) // store pre-sampled ids
        })
        var shuffled = _.shuffle(nonHeadings)
        var hiddenItems = _.slice(shuffled, samplingAmount)
        _.remove(hiddenIds) // clear array
        _.each(hiddenItems, function(item) {
          hiddenIds.push(item.id) // store hidden ids
        })
      }

      return _.filter(choicesOrStatements, function(item) {
        if (item.data.isHeading) return true
        return !_.includes(hiddenIds, item.id)
      })
    }

    ResponderQuestion.prototype.filterChoicesBySampling = function(choices) {
      return filterChoicesOrStatementsBySampling(
        choices,
        this.choiceSamplingEnabled,
        this.choiceSamplingAmount,
        this.hiddenChoiceIds,
        this.prevPreSampledChoiceIds
      )
    }

    ResponderQuestion.prototype.filterStatementsBySampling = function(
      statements
    ) {
      return filterChoicesOrStatementsBySampling(
        statements,
        this.statementSamplingEnabled,
        this.statementSamplingAmount,
        this.hiddenStatementIds,
        this.prevPreSampledStatementIds
      )
    }

    ResponderQuestion.prototype.populateChoicePipes = function() {
      // Note: using choice.option and statement.statement is
      // deprecated in favor of a single .label field
      // For now we populate both but we should be moving away from it
      var self = this
      _.each(self.choices, function(choice) {
        if (!choice.pipes)
          choice.pipes = new Pipes(choice.option || choice.label)
        var label = self.responder.injectValues(choice.pipes, self.loopKey)
        choice.option = label
        choice.label = label
      })
      _.each(self.statements, function(statement) {
        if (!statement.pipes)
          statement.pipes = new Pipes(statement.statement || statement.label)
        var label = self.responder.injectValues(statement.pipes, self.loopKey)
        statement.statement = label
        statement.label = label
      })
    }

    ResponderQuestion.prototype.getVisibleChoices = function(includeHeadings) {
      var self = this
      var visibleChoices

      // The selections for a place question are always "visible" choices, and we
      // don't want the code below to filter them out because the available choices
      // come from an API, not the choices array.
      if (self.type === Types.PLACE) return self.choices.slice()

      if (!self.choiceLender.id) {
        visibleChoices = self.choices.slice() // shallow immutable copy is needed
      } else {
        visibleChoices = self.filterChoicesOrStatementsByLender(
          self.choiceLender,
          self.choices
        )
      }

      visibleChoices = self.filterChoicesOrStatementsByDisplayLogic(
        visibleChoices,
        Logic.Targets.CHOICES
      )

      visibleChoices = self.filterChoicesBySampling(visibleChoices)

      if (!includeHeadings) {
        visibleChoices = visibleChoices.filter(function(choice) {
          if (choice.data && choice.data.isHeading) {
            return false
          }
          return true
        })
      }

      /**
       * If the user makes selections here and then goes back to the
       * lender question and changes something, we need to make sure
       * anything they've selected that isn't shown here anymore is
       * un-selected
       */
      self.selected.forEach(function(choice) {
        var isInvalid = !_.find(visibleChoices, { id: choice.id })
        if (isInvalid) {
          _.remove(self.selected, { id: choice.id })
        }
      })
      _.each(self.statementAnswers, function(selected, statementId) {
        selected.forEach(function(choice) {
          var isInvalid = !_.find(visibleChoices, { id: choice.id })
          if (isInvalid) {
            _.remove(selected, { id: choice.id })
          }
        })
      })
      return visibleChoices
    }

    ResponderQuestion.prototype.getVisibleStatements = function(
      includeHeadings
    ) {
      var self = this
      var visibleStatements

      if (!self.statementLender.id) {
        visibleStatements = self.statements.slice() // shallow immutable copy is needed
      } else {
        visibleStatements = self.filterChoicesOrStatementsByLender(
          self.statementLender,
          self.statements
        )
      }

      visibleStatements = self.filterChoicesOrStatementsByDisplayLogic(
        visibleStatements,
        Logic.Targets.STATEMENTS
      )

      visibleStatements = self.filterStatementsBySampling(visibleStatements)

      if (!includeHeadings) {
        visibleStatements = visibleStatements.filter(function(choice) {
          if (choice.data && choice.data.isHeading) {
            return false
          }
          return true
        })
      }

      /**
       * If the user makes selections here and then goes back to the
       * lender question and changes something, we need to make sure
       * anything they've selected that isn't shown here anymore is
       * un-selected
       */
      _.each(self.statementAnswers, function(selected, statementId) {
        var visible = _.some(visibleStatements, function(statement) {
          return statement.id === statementId
        })
        if (!visible) _.remove(selected)
      })
      return visibleStatements
    }

    ResponderQuestion.prototype.getChoicesAsBlocks = function(choices) {
      var blocks = []
      /**
       * Choices with headings result in a block per heading containing its choices.
       * No headings results in a single block of choices with no heading
       *
       */
      choices.forEach(function(choice) {
        var block = blocks[blocks.length - 1]
        if (choice.data.isHeading) {
          if (block && !block.choices.length) {
            // If the previous block has no choices we don't want to
            // show an empty block so we just replace it with
            // this new heading
            block.heading = choice
          } else {
            blocks.push({ heading: choice, choices: [] })
          }
        } else {
          if (!block) {
            block = { heading: null, choices: [] }
            blocks.push(block)
          }
          block.choices.push(choice)
        }
      })
      // if the last block has no choices, its just a heading so remove it
      var last = blocks[blocks.length - 1]
      if (last && !last.choices.length) {
        blocks.pop()
      }
      return blocks
    }

    /**
     * If a question borrows only choices selected from a previous question
     * and the respondent selected "other" then there would be no choices
     * to show the user when they get to this one. We treat this like a hidden
     * question and the respondent moves to the next valid view.
     *
     * The scenario described above is one of a few different ways this can occur.
     * Another scenario is when using display logic targeting statements/choices,
     * and if there's no visible statements/choices then the question is hidden
     */
    ResponderQuestion.prototype.isHiddenByInsufficientOptions = function() {
      var self = this
      if (self.statements.length) {
        return !(
          self.getVisibleStatements().length && self.getVisibleChoices().length
        )
      }
      if (self.choices.length) {
        return !self.getVisibleChoices().length
      }
      return false
    }

    /**
     * If a question is compulsory and has only 1 visible choice, we auto punch
     * the only choice to the answer and the question will not be displayed
     */
    ResponderQuestion.prototype.autoPunched = function() {
      var self = this
      var isType = _.includes(
        [Types.RANK, Types.CHOICE, Types.SCALE, Types.MATRIX, Types.SCORE],
        self.type
      )
      if (!self.isCompulsory || !isType) return false

      var visibleChoices = self.getVisibleChoices()
      var visibleStatements = self.getVisibleStatements()

      if (visibleChoices.length !== 1) {
        if (self.isAutoPunched) {
          // clear the auto punched answer
          if (visibleStatements.length) {
            _.each(visibleStatements, function(statement) {
              self.setSelected(null, statement)
            })
          } else {
            self.setSelected(null)
          }
          self.isAutoPunched = false
        }
        // can't auto punch because amount of visible choices is not 1
        return false
      }

      var punchChoice = visibleChoices[0]

      if (punchChoice.data.isCapture) {
        // we can't auto-punch a text capture choice
        return false
      }

      // auto punch the only choice to the answer
      if (visibleStatements.length) {
        _.each(visibleStatements, function(statement) {
          self.setSelected(punchChoice, statement)
        })
      } else {
        self.setSelected(punchChoice)
      }
      self.isAutoPunched = true
      return true
    }

    ResponderQuestion.prototype.filterChoicesOrStatementsByDisplayLogic = function(
      choicesOrStatements,
      target
    ) {
      var self = this
      var displayLogic = _.filter(self.logic, function(logic) {
        return logic.type === logic.Types.DISPLAY && logic.target === target
      })
      if (!displayLogic.length) return choicesOrStatements

      // return all but exclude items with display logic that don't
      // meet their conditions. (require only 1 logic to pass)
      return _.filter(choicesOrStatements, function(item) {
        // filter display logic on this item
        var itemDisplayLogic = _.filter(displayLogic, function(logic) {
          if (logic.targetsChoices()) {
            return _.includes(logic.choiceIds, item.id)
          }
          if (logic.targetsStatements()) {
            return _.includes(logic.statementIds, item.id)
          }
          return false
        })

        // return true if there's no display logic on this item
        if (!itemDisplayLogic.length) return true

        // return true if any of the logic has their conditions met
        return _.some(itemDisplayLogic, function(logic) {
          return self.responder.allConditionsMet(logic.conditions, self.loopKey)
        })
      })
    }

    ResponderQuestion.prototype.getSelected = function(statement) {
      var selected = statement
        ? this.statementAnswers[statement.id]
        : this.selected
      return selected
    }

    ResponderQuestion.prototype.isSelected = function(
      valueOrPredicate,
      statement
    ) {
      var selected = this.getSelected(statement)
      return !!_.find(selected, valueOrPredicate)
    }

    ResponderQuestion.prototype.canSelectMore = function(statement) {
      var didSelectExclusive = this.isSelected(function(choice) {
        return choice.data && choice.data.isExclusive
      }, statement)
      if (didSelectExclusive) return false

      var selected = this.getSelected(statement)
      return selected.length < this.maxSelections
    }

    ResponderQuestion.prototype.canContinue = function() {
      var self = this
      if (self.type === Types.FOLLOWUP) {
        return self.isAnswered()
      }
      if (!self.isCompulsory) {
        // if its not compulsory, the answer still needs to be valid
        return self.isValidAnswer()
      }
      if (
        self.type === Types.LOCATION &&
        self.locationType === LocationTypes.PLACES &&
        self.data &&
        self.data.allowLocationToPass
      ) {
        // if location type is PLACES and there are no results
        // for respondent to choose, we let them go next
        return true
      }
      return self.isAnswered()
    }

    ResponderQuestion.prototype.isValidAnswer = function() {
      var self = this
      /* This check is used specifically when a question is optional
       * but the answer may be invalid. The respondent can
       * usually continue the survey on optional questions but
       * if they provided an answer that was invalid then they
       * must be prevented from continuing.
       */
      if (self.type === Types.TEXT) {
        return _.every(self.texts, function(text) {
          if (!text) return true // no answer is valid
          if (!self.textValidator && self.minCharacters > 0) {
            return text.length >= self.minCharacters
          }
          if (self.textValidator === 'EMAIL') {
            return glEmail.isValid(text)
          }
          if (self.textValidator === 'NUMERIC') {
            return NUMERIC_REGEX.test(text)
          }
          if (self.textValidator === 'NUMERIC_RANGE') {
            if (!NUMERIC_REGEX.test(text)) return false
            var num = +text // coerce to number
            var isInRange =
              num >= self.textNumericMin && num <= self.textNumericMax
            return isInRange
          }
          return true
        })
      }
      if (
        self.type === Types.TEXTAREA &&
        !!self.text &&
        self.minCharacters > 0
      ) {
        return self.text.length >= self.minCharacters
      }
      if (self.type === Types.CONSTANT_SUM) {
        // If a respondent enters a value into any constant sum field,
        // they must enter values for ALL fields and
        // required total validation must be met to continue
        this.constantSumInvalidTotals = []
        var choices = self.getVisibleChoices()
        var isValid
        if (self.matrixEnabled) {
          var statements = self.getVisibleStatements()
          var fullyAnsweredCount = 0
          var validStatementsCount = 0
          _.each(statements, function(statement) {
            var validation = self.validateConstantSumTotal(statement)
            if (!validation.isValid) {
              self.constantSumInvalidTotals.push(validation)
            }
            var selected = self.statementAnswers[statement.id]
            var isChoicesFullyAnswered = selected.length === choices.length
            if (isChoicesFullyAnswered) {
              fullyAnsweredCount++
            }
            if (
              validation.isValid &&
              (!selected.length || isChoicesFullyAnswered)
            ) {
              validStatementsCount++
            }
          })
          this.isConstantSumFullyAnswered =
            fullyAnsweredCount === statements.length
          isValid = validStatementsCount === statements.length
        } else {
          var validation = this.validateConstantSumTotal()
          if (!validation.isValid) {
            this.constantSumInvalidTotals.push(validation)
          }
          var isChoicesFullyAnswered = this.selected.length === choices.length
          if (isChoicesFullyAnswered) {
            this.isConstantSumFullyAnswered = true
          }
          isValid =
            validation.isValid &&
            (!this.selected.length || isChoicesFullyAnswered)
        }
        return isValid
      }
      if (_.includes([Types.CHOICE, Types.RANK, Types.MATRIX], self.type)) {
        // if respondent selected text capture choice, they must enter text
        // currently text capture choice is supported in Choice, Rank and Matrix questions
        var isValid
        if (self.isUsedAsMatrix()) {
          isValid = _.every(self.getVisibleStatements(), function(statement) {
            if (!self.isCaptureSelected(statement)) return true
            return _.every(self.getSelectedTextCaptures(statement), function(
              choice
            ) {
              return !!self.statementTextCaptureValues[statement.id][choice.id]
            })
          })
        } else if (self.isCaptureSelected()) {
          isValid = _.every(self.getSelectedTextCaptures(), function(choice) {
            return !!choice.textCaptureValue
          })
        } else {
          isValid = true
        }
        return isValid
      }
      return true
    }

    ResponderQuestion.prototype.validateConstantSumTotal = function(statement) {
      var total = this.getSelectedTotalNumber(statement)
      var quantifier = this.constantSumTotalQuantifier
      var validation = {
        isValid: true,
        total: total,
        quantifier: quantifier,
        statementId: statement ? statement.id : null,
        statementLabel: statement ? statement.label : null,
      }
      if (!quantifier) {
        return validation
      }

      var override = statement
        ? _.find(this.constantSumStatementRules, { statementId: statement.id })
        : null
      var constraints = {
        total: override ? override.total : this.constantSumTotal,
        min: override ? override.min : this.constantSumTotalMin,
        max: override ? override.max : this.constantSumTotalMax,
      }
      var isValid
      switch (quantifier) {
        case 'EQUAL':
          isValid = total === constraints.total
          break
        case 'LESS_THAN':
          isValid = total < constraints.total
          break
        case 'LESS_THAN_OR_EQUAL':
          isValid = total <= constraints.total
          break
        case 'GREATER_THAN':
          isValid = total > constraints.total
          break
        case 'GREATER_THAN_OR_EQUAL':
          isValid = total >= constraints.total
          break
        case 'BETWEEN':
          // if by any chance the minimum is greater or equal to the maximum
          // (this could happen when using pipe from previous numeric answer)
          // then we can't validate this correctly so we just assume it's valid
          isValid =
            constraints.min >= constraints.max ||
            (total > constraints.min && total < constraints.max)
          break
      }
      validation.isValid = isValid
      validation.constraints = constraints
      return validation
    }

    ResponderQuestion.prototype.getSelectedTotalNumber = function(statement) {
      var selected = this.getSelected(statement)
      var total = _.sumBy(selected, 'numberValue')
      return total
    }

    ResponderQuestion.prototype.makeTotalTextValue = function(statement) {
      var validation = _.find(this.constantSumInvalidTotals, {
        statementId: statement ? statement.id : null,
      })
      if (!validation) {
        // if total is valid, then don't show the suffix
        return this.getSelectedTotalNumber(statement) + '' // coerce to text
      }
      var total = validation.total
      var quantifier = validation.quantifier
      var constraints = validation.constraints
      var operators = {
        EQUAL: '=',
        LESS_THAN: '<',
        LESS_THAN_OR_EQUAL: '<=',
        GREATER_THAN: '>',
        GREATER_THAN_OR_EQUAL: '>=',
        BETWEEN: total <= constraints.min ? '>' : '<',
      }
      var bound = constraints.total
      if (quantifier === 'BETWEEN') {
        bound = total <= constraints.min ? constraints.min : constraints.max
      }
      return total + ' [' + operators[quantifier] + bound + ']'
    }

    ResponderQuestion.prototype.makeHelperText = function() {
      var self = this
      var text = ''
      switch (this.type) {
        case Types.CONSTANT_SUM:
          if (
            !this.isConstantSumFullyAnswered ||
            !this.constantSumInvalidTotals ||
            !this.constantSumInvalidTotals.length
          ) {
            break
          }

          var startText = 'Sum of values '
          var instructions = {
            EQUAL: 'must be exactly ',
            LESS_THAN: 'must be less than ',
            LESS_THAN_OR_EQUAL: 'must be less than or equal to ',
            GREATER_THAN: 'must be greater than ',
            GREATER_THAN_OR_EQUAL: 'must be greater than or equal to ',
            BETWEEN: 'must be between ',
          }
          var items = []
          this.constantSumInvalidTotals.forEach(function(validation) {
            var quantifier = validation.quantifier
            var constraints = validation.constraints
            var valueText =
              quantifier === 'BETWEEN'
                ? constraints.min + '** and **' + constraints.max
                : constraints.total
            var instructionText =
              instructions[quantifier] + '**' + valueText + '**'
            var item = _.find(items, { instructionText: instructionText })
            if (!item) {
              item = {
                instructionText: instructionText,
                statementLabels: [],
              }
              items.push(item)
            }
            if (validation.statementLabel) {
              item.statementLabels.push('**' + validation.statementLabel + '**')
            }
          })
          var texts = _.map(items, function(item) {
            var str = item.statementLabels.length
              ? 'for ' + item.statementLabels.join(', ') + ' '
              : ''
            return startText + str + item.instructionText
          })
          text = texts.join('\n')
          break
      }
      return text
    }

    ResponderQuestion.prototype.getSelectedNumber = function(
      choice,
      statement
    ) {
      var selected = this.getSelected(statement)
      var selectedChoice = _.find(selected, { id: choice.id })
      return selectedChoice ? selectedChoice.numberValue : null
    }

    ResponderQuestion.prototype.setSelectedNumber = function(
      number,
      choice,
      statement
    ) {
      var selected = this.getSelected(statement)
      if (_.isNumber(number) && !_.isNaN(number)) {
        var selectedChoice = _.find(selected, { id: choice.id })
        if (selectedChoice) {
          selectedChoice.numberValue = number
        } else {
          var value = _.cloneDeep(choice)
          value.numberValue = number
          selected.push(value)
        }
      } else {
        _.remove(selected, { id: choice.id })
      }
    }

    ResponderQuestion.prototype.setLocationAnswer = function(locality) {
      if (!locality) {
        this.text = null
      } else {
        // Format the locality object into a string
        // Note: locality is created using geocodeService.createLocalityObj()
        // The locality object may be incomplete and will be fully populated later on submission
        this.text = [
          locality.country,
          locality.state,
          locality.city,
          locality.suburb,
          locality.postcode,
          locality.lat + ',' + locality.lng,
          locality.name,
          locality.address,
          locality.type,
          locality.placeId,
        ].join('|')
      }
    }

    ResponderQuestion.prototype.clampNumber = function(number) {
      if (_.isNumber(this.numberInterval)) {
        // https://stackoverflow.com/questions/43890561/how-to-round-number-to-the-closest-50-in-javascript
        number = Math.round(number / this.numberInterval) * this.numberInterval
      }
      number = _.clamp(number, this.numberMinValue, this.numberMaxValue)
      return number
    }

    ResponderQuestion.prototype.injectConstantSumPipesValue = function() {
      var self = this

      function getInjectedValue(pipesObj) {
        var value = self.responder.injectValues(pipesObj, self.loopKey)
        var num = +value // coerce to number
        return _.isNaN(num) ? null : num
      }

      // Update question-level total, min, max if pipes exist
      if (this.constantSumTotalPipes.pipes.length) {
        this.constantSumTotal = getInjectedValue(this.constantSumTotalPipes)
      }
      if (this.constantSumTotalMinPipes.pipes.length) {
        this.constantSumTotalMin = getInjectedValue(
          this.constantSumTotalMinPipes
        )
      }
      if (this.constantSumTotalMaxPipes.pipes.length) {
        this.constantSumTotalMax = getInjectedValue(
          this.constantSumTotalMaxPipes
        )
      }
      if (this.matrixEnabled) {
        // Update statement-level total, min, max if pipes exist
        _.each(this.constantSumStatementRules, function(rule) {
          if (rule.totalPipes.pipes.length) {
            rule.total = getInjectedValue(rule.totalPipes)
          }
          if (rule.minPipes.pipes.length) {
            rule.min = getInjectedValue(rule.minPipes)
          }
          if (rule.maxPipes.pipes.length) {
            rule.max = getInjectedValue(rule.maxPipes)
          }
        })
      }
    }

    ResponderQuestion.prototype.isUsedAsMatrix = function() {
      return this.type === Types.MATRIX || this.matrixEnabled
    }

    ResponderQuestion.prototype.isCaptureSelected = function(statement) {
      var selected = this.getSelected(statement)
      return _.some(selected, function(choice) {
        return choice.data && choice.data.isCapture
      })
    }

    ResponderQuestion.prototype.getSelectedTextCaptures = function(statement) {
      var selected = this.getSelected(statement)
      return _.filter(selected, function(choice) {
        return choice.data && choice.data.isCapture
      })
    }

    ResponderQuestion.prototype.runPostValidation = function(viewIndex) {
      var self = this

      function getTextAnswers() {
        return self.type === Types.TEXT ? self.getValidTexts() : [self.text]
      }

      // text based ai quality filter
      if (
        (self.type === Types.TEXT || self.type === Types.TEXTAREA) &&
        self.isAnswered() &&
        self.responder.aiQualityFilterEnabled
      ) {
        var questionTitle = self.getInjectedTitle()
        var textAnswers = getTextAnswers()

        var promises = textAnswers.map(function(textAnswer) {
          return self.responder.validateTextAnswer(questionTitle, textAnswer)
        })

        var deferred = $q.defer()
        self.responder.preSubmits.push(deferred.promise)

        $q.all(promises).then(function(validAnswers) {
          var currentAnswers = getTextAnswers()
          var isMatch = currentAnswers.join() === textAnswers.join()

          if (isMatch && !_.every(validAnswers)) {
            self.responder.applyTags([
              {
                type: 'ADD',
                tag: 'AI_TEXT_ISSUE',
                givenByViewIndex: viewIndex,
              },
            ])
          }
          deferred.resolve()
        })
      }
    }

    ResponderQuestion.prototype.fromServer = function(question, options) {
      var self = this
      this.serverData = _.cloneDeep(question)
      options = options || {}

      // undo backend behaviour changes (until available for all types)
      glSurveyUtils.undoQuestionBehaviours(question)

      // prevent idx/existential problems below
      question.profiling = _.isPlainObject(question.profiling)
        ? question.profiling
        : {}
      question.data = _.isPlainObject(question.data) ? question.data : {}
      question.numericTypeConstraint = _.isPlainObject(
        question.numericTypeConstraint
      )
        ? question.numericTypeConstraint
        : {}
      _.each(question.choices, function(choice) {
        choice.data = _.isPlainObject(choice.data) ? choice.data : {}
      })
      _.each(question.statements, function(statement) {
        statement.data = _.isPlainObject(statement.data) ? statement.data : {}
      })

      // core
      this.id = question.id
      this.imageUrl = question.imageUrl
      this.isCompulsory = question.isCompulsory
      this.isSeen = false

      this.imageFromLoop = question.data.imageFromLoop

      // responderQuestion.number is defined after questions are shuffled and
      // hidden questions are removed. This could cause mismatch with pipes directive number
      // we need original question number to correctly match with the pipes
      this.originalNumber = question.extras.number

      // title/pipes/selector
      this.titleSelector = question.data.titleSelector
      if (options.isTemplate && this.titleSelector) {
        this.title = titleSelector.format(this.titleSelector)
        this.titlePipes = new Pipes(this.title)
      } else {
        this.title = question.title
        this.titlePipes = new Pipes(this.title)
      }

      // logic
      this.logic = _.map(question.data.logic || [], function(logic) {
        return new Logic(null).deserialize(logic).randomize()
      })

      // autocomplete
      this.autocompleteKey = question.profiling.key
      this.submitAsDimension = question.profiling.submitAsDimension
      this.autocompletedByIdentity = null
      // SPECIAL: some autocomplete-key questions are displayed differently, so we map them to new
      // custom question types now to reduce hacks further down the line.
      this.type = AutocompleteKeyTypes[this.autocompleteKey] || question.type

      // HACK: Types.LOCATION needs to be stored in the BE as Types.TEXT
      // until the BE supports the type first class
      if (question.type === 'text' && question.data.isLocationType) {
        this.type = 'location'
      }

      // choices
      this.choices = _.filter(question.choices, function(choice) {
        // remove hidden choices
        return !choice.data.isHidden
      })
      _.each(this.choices, function(choice, index) {
        choice.number = index + 1
        // attempt to set a numeric representation of choice.option
        choice.numericOption = parseInt(choice.option)

        // set textCaptureValue field when choice is capture type
        // this field is also the data model for input text
        // BUT not for matrix question. Matrix choice text capture model
        // is defined below in it's own field `statementTextCaptureValues`
        if (choice.data.isCapture) {
          choice.textCaptureValue = ''
        }
      })

      // copy a reference list of choices that are not other or scratch
      this.hasChoiceImages = _.some(this.choices, function(choice) {
        return choice.data.imageUrl
      })
      if (question.type === Types.MOOD) {
        // add labels for mood type
        _.each(self.choices, function(choice) {
          choice.label = choice.option
          // choice.label = _.find(self.MoodInfo, { value: choice.option }).label
        })
      }
      this.minSelections = _.isNumber(question.minSelections)
        ? question.minSelections
        : 0
      this.maxSelections = _.isNumber(question.maxSelections)
        ? question.maxSelections
        : 666
      this.isMulti = this.maxSelections !== 1

      this.choiceLender = new Lender().deserialize(question.data.choiceLender)
      this.statementLender = new Lender().deserialize(
        question.data.statementLender
      )

      // statements
      this.statements = _.filter(question.statements, function(statement) {
        // remove hidden statements
        return !(statement.data && statement.data.isHidden)
      })

      this.hasStatementImages = _.some(this.statements, function(statements) {
        return statements.data.imageUrl
      })

      /**
       * Randomization (BEGIN)
       */

      function getIsAnchoredChoice(choice) {
        return choice.data.isAnchored
      }

      function getIsAnchoredBlock(block) {
        return block.heading && block.heading.data.isAnchored
      }

      var randomizer = new Randomizer()
      var shuffle = randomizer.shuffle
      var rotate = randomizer.rotate
      var flip = randomizer.flip

      var randomizeChoices = question.data.randomizeChoices
      var randomizeChoiceHeadings = question.data.randomizeChoiceHeadings
      if (randomizeChoices || randomizeChoiceHeadings) {
        var blocks = self.getChoicesAsBlocks(self.choices)
        // heading randomization
        if (randomizeChoiceHeadings === 'SHUFFLE') {
          shuffle(blocks, getIsAnchoredBlock)
        }
        if (randomizeChoiceHeadings === 'ROTATE') {
          rotate(blocks, getIsAnchoredBlock)
        }
        if (randomizeChoiceHeadings === 'FLIP') {
          flip(blocks, getIsAnchoredBlock)
        }
        // choice randomization
        blocks.forEach(function(block) {
          if (randomizeChoices === 'SHUFFLE') {
            shuffle(block.choices, getIsAnchoredChoice)
          }
          if (randomizeChoices === 'ROTATE') {
            rotate(block.choices, getIsAnchoredChoice)
          }
          if (randomizeChoices === 'FLIP') {
            flip(block.choices, getIsAnchoredChoice)
          }
        })
        // rebuild the choices array from blocks
        self.choices = []
        blocks.forEach(function(block) {
          if (block.heading) {
            self.choices.push(block.heading)
          }
          block.choices.forEach(function(choice) {
            self.choices.push(choice)
          })
        })
      }

      var randomizeStatements = question.data.randomizeStatements
      var randomizeStatementHeadings = question.data.randomizeStatementHeadings
      if (randomizeStatements || randomizeStatementHeadings) {
        var blocks = this.getChoicesAsBlocks(this.statements)
        // heading randomization
        if (randomizeStatementHeadings === 'SHUFFLE') {
          shuffle(blocks, getIsAnchoredBlock)
        }
        if (randomizeStatementHeadings === 'ROTATE') {
          rotate(blocks, getIsAnchoredBlock)
        }
        if (randomizeStatementHeadings === 'FLIP') {
          flip(blocks, getIsAnchoredBlock)
        }
        // choice randomization
        blocks.forEach(function(block) {
          if (randomizeStatements === 'SHUFFLE') {
            shuffle(block.choices, getIsAnchoredChoice)
          }
          if (randomizeStatements === 'ROTATE') {
            rotate(block.choices, getIsAnchoredChoice)
          }
          if (randomizeStatements === 'FLIP') {
            flip(block.choices, getIsAnchoredChoice)
          }
        })
        // rebuild the statements array from blocks
        self.statements = []
        blocks.forEach(function(block) {
          if (block.heading) {
            self.statements.push(block.heading)
          }
          block.choices.forEach(function(choice) {
            self.statements.push(choice)
          })
        })
      }

      /**
       * Randomization (END)
       */

      // Hide Labels
      this.choiceLabelsHidden = question.data.choiceLabelsHidden
      this.statementLabelsHidden = question.data.statementLabelsHidden

      // show image and label
      this.isChoiceImageAndLabel =
        this.hasChoiceImages && !this.choiceLabelsHidden
      this.isStatementImageAndLabel =
        this.hasStatementImages && !this.statementLabelsHidden

      // choice sampling
      this.hiddenChoiceIds = []
      this.choiceSamplingEnabled = question.choiceSamplingEnabled
      this.choiceSamplingAmount = question.choiceSamplingAmount
      // keep previous pre-sampled visible choice ids to compare with
      // current pre-sampled visible choice ids
      this.prevPreSampledChoiceIds = []

      // statement sampling
      this.hiddenStatementIds = []
      this.statementSamplingEnabled = question.statementSamplingEnabled
      this.statementSamplingAmount = question.statementSamplingAmount
      // keep previous pre-sampled visible statement ids to compare with
      // current pre-sampled visible statement ids
      this.prevPreSampledStatementIds = []

      // matrix
      this.matrixEnabled = question.data.matrixEnabled
      this.flipTableAxis = question.data.flipTableAxis
      this.matrixUniqueSelection = question.matrixUniqueSelection

      // placesnearme
      this.placesSearch = question.showSearchField
      this.placesSearchTerms = question.placesSearchTerms
      this.placesSearchTermsPipes = new Pipes(question.placesSearchTerms)
      this.placesSubscriberId = question.subscriberIdFilter

      // age_year_of_birth uses dynamic values, set them up here
      if (question.profiling.key === 'age_year_of_birth') {
        var max = moment().get('year') - 14
        var steps = 100
        question.numericTypeConstraint.maxValue = max
        question.numericTypeConstraint.minValue = max - steps
        question.numericTypeConstraint.steps = steps
        question.numericTypeConstraint.unit = 'number-pure'
      }

      // numeric
      this.numericMin = question.numericTypeConstraint.minValue
      this.numericMax = question.numericTypeConstraint.maxValue
      this.numericSteps = question.numericTypeConstraint.steps
      this.numericUnit = question.numericTypeConstraint.unit
      this.numericLabels = question.data.numericLabels
      this.numericDiff = question.data.numericDiff
      this.numericDiffLeft = question.data.numericDiffLeft
      this.numericDiffRight = question.data.numericDiffRight
      if (question.type === Types.NUMERIC) {
        this.choices = numericService.calculateValues(
          self.numericMin,
          self.numericMax,
          self.numericSteps,
          self.numericUnit,
          self.numericLabels
        )
      }

      this.textFieldNumber = question.textFieldNumber
      this.textValidator = question.data.textValidator || null
      this.textNumericMin = question.data.textNumericMin
      this.textNumericMax = question.data.textNumericMax
      this.minAnswers = question.data.minAnswers

      // common
      this.numberMinValue = question.data.numberMinValue
      this.numberMaxValue = question.data.numberMaxValue
      this.numberInterval = question.data.numberInterval
      this.textPrefix = question.data.textPrefix
      this.textPrefixPipes = new Pipes().set(this.textPrefix)
      this.textSuffix = question.data.textSuffix
      this.textSuffixPipes = new Pipes().set(this.textSuffix)

      // constant sum
      this.constantSumTotal = question.data.constantSumTotal
      this.constantSumTotalPipes = new Pipes()
      if (_.isString(this.constantSumTotal)) {
        this.constantSumTotalPipes.set(this.constantSumTotal)
        this.constantSumTotal = null
      }
      this.constantSumTotalMin = question.data.constantSumTotalMin
      this.constantSumTotalMinPipes = new Pipes()
      if (_.isString(this.constantSumTotalMin)) {
        this.constantSumTotalMinPipes.set(this.constantSumTotalMin)
        this.constantSumTotalMin = null
      }
      this.constantSumTotalMax = question.data.constantSumTotalMax
      this.constantSumTotalMaxPipes = new Pipes()
      if (_.isString(this.constantSumTotalMax)) {
        this.constantSumTotalMaxPipes.set(this.constantSumTotalMax)
        this.constantSumTotalMax = null
      }
      this.constantSumTotalQuantifier = question.data.constantSumTotalQuantifier
      this.constantSumShowTotal = question.data.constantSumShowTotal
      this.constantSumStatementRules = _.map(
        question.data.constantSumStatementRules || [],
        function(rule) {
          return {
            statementId: rule.statementId,
            total: _.isString(rule.total) ? null : rule.total,
            min: _.isString(rule.min) ? null : rule.min,
            max: _.isString(rule.max) ? null : rule.max,
            totalPipes: new Pipes(_.isString(rule.total) ? rule.total : ''),
            minPipes: new Pipes(_.isString(rule.min) ? rule.min : ''),
            maxPipes: new Pipes(_.isString(rule.max) ? rule.max : ''),
          }
        }
      )

      // score
      this.scoreLeftExtremityLabel = question.data.scoreLeftExtremityLabel
      this.scoreRightExtremityLabel = question.data.scoreRightExtremityLabel

      // answers
      this.selected = []
      this.texts = new Array(this.textFieldNumber) // for single text question
      this.text = null
      this.email = null
      this.fullname = null
      this.image = null
      this.imageData = null

      // min characters
      this.minCharacters = _.isNumber(question.data.minCharacters)
        ? question.data.minCharacters
        : 0

      this.statementAnswers = {}
      this.statementTextCaptureValues = {}
      _.each(this.statements, function(statement) {
        self.statementAnswers[statement.id] = []
        self.statementTextCaptureValues[statement.id] = {}
        // matrix choice text capture model mapping by statementId and choiceId
        _.each(self.choices, function(choice) {
          if (choice.data && choice.data.isCapture) {
            self.statementTextCaptureValues[statement.id][choice.id] = ''
          }
        })
      })

      // this defaultsDeep call is expensive when `survey` is in the options
      // so we pull it out manually for a huge performance win
      if (options.survey) {
        this.survey = options.survey
        delete options.survey
      }
      _.defaultsDeep(this, options, _.cloneDeep(Defaults))

      // display type
      this.displayType = question.data.displayType

      // location
      this.locationBiasCountryCode = question.data.locationBiasCountryCode
      this.locationRestrictCountryCode =
        question.data.locationRestrictCountryCode
      this.locationType = question.data.locationType
      this.locationSearchTerms = question.data.locationSearchTerms
      this.locationSearchTermsPipes = new Pipes(this.locationSearchTerms)
      this.locationShowSearchField = question.data.locationShowSearchField
      this.locationTypesFilter = question.data.locationTypesFilter
      this.locationExcludePrevious = question.data.locationExcludePrevious

      // description
      this.description = question.data.description
      this.descriptionPipes = new Pipes(this.description)

      this.choiceGridColumnMax = question.data.choiceGridColumnMax

      return this
    }

    /**
     * @name To Server
     * @desc serializes this question into data for the service
     * @returns {Object} data - The data for use with the service
     */
    ResponderQuestion.prototype.toServer = function() {
      var self = this
      var data = {}

      data.questionId = self.loopKey ? self.loopCanonicalId : self.id
      data.choiceAnswers = []
      data.placesAnswers = []
      data.statementAnswers = []
      data.hiddenChoiceIds = self.hiddenChoiceIds
      data.hiddenStatementIds = self.hiddenStatementIds
      // force set seen to true when question is auto punched
      data.seen = self.isAutoPunched ? true : self.isSeen
      data.loopKey = self.loopKey

      // send list of choices/statements that were not seen
      // by the respondent
      var visibleChoices = self.getVisibleChoices()
      if (self.type !== Types.NUMERIC) {
        // exclude Numeric type question from getting hidden choice ids
        // based on visible choices because numeric choices are generated
        // in runtime and they don't have ids
        data.hiddenChoiceIds = _(self.choices)
          .filter(function(choice) {
            return !_.find(visibleChoices, { id: choice.id })
          })
          .map('id')
          .value()
      }
      var visibleStatements = self.getVisibleStatements()
      data.hiddenStatementIds = _(self.statements)
        .filter(function(statement) {
          return !_.find(visibleStatements, { id: statement.id })
        })
        .map('id')
        .value()

      if (
        !self.isSeen &&
        !self.autocompletedByIdentity &&
        !self.isAutoPunched
      ) {
        data.textAnswer = '<not-asked>'
        return data
      }

      data.duration = self.timer.getDurationInSeconds(1)

      self.recalculateRanks()

      switch (self.type) {
        case Types.RANK:
        case Types.CHOICE:
        case Types.SCALE:
        case Types.RATING:
        case Types.SEX:
        case Types.AGE_RANGE:
          data.choiceAnswers = _.map(self.selected, function(item) {
            // only pick id/option/rank keys
            var choiceAnswer = {
              id: item.id,
              option: item.option,
              rank: item.rank + 1,
            }
            if (item.data.isCapture) {
              choiceAnswer.text = item.textCaptureValue
            }
            return choiceAnswer
          })
          break
        case Types.MATRIX:
          _.each(self.statementAnswers, function(choices, statementId) {
            var statement = _.find(self.statements, { id: statementId })
            _.each(choices, function(choice) {
              var statementAnswer = {
                id: statementId,
                statement: statement.statement,
                optionId: choice.id,
                option: choice.option,
              }
              if (choice.data.isCapture) {
                statementAnswer.text =
                  self.statementTextCaptureValues[statement.id][choice.id]
              }
              data.statementAnswers.push(statementAnswer)
            })
          })
          break
        case Types.TEXT:
          data.textAnswer = self
            .getValidTexts()
            .map(function(text) {
              // The pipe character `|` is reserved as delimiter for multi text
              // questions. We remove them from respondent answers before
              // we concatenate them back together using a pipe
              return text.replace(/\|/g, '')
            })
            .join('|')
          break
        case Types.TEXTAREA:
        case Types.SCAN:
        case Types.LOCATION:
          if (self.text) {
            data.textAnswer = self.text
          }
          break
        case Types.NPS:
        case Types.MOOD:
          // TODO: stop using textAnswer and use choiceAnswers instead
          var choice = self.selected[0]
          if (choice) {
            data.textAnswer = choice.option
            data.choiceAnswers = [
              {
                id: choice.id,
                option: choice.option,
              },
            ]
          }
          break
        case Types.PLACE:
          data.placesAnswers = _.cloneDeep(self.selected)
          break
        case Types.IMAGE:
          if (self.image) {
            data.textAnswer = self.image
          }
          break
        case Types.FOLLOWUP:
          data.choiceAnswers = _.map(self.selected, function(item) {
            // only pick id/option keys
            return {
              id: item.id,
              option: item.option,
            }
          })
          if (self.selected.length && self.email) {
            data.textAnswer = self.email
          }
          break
        case Types.NUMERIC:
          var value = self.selected[0]
          if (value) {
            if (self.autocompleteKey === 'age_year_of_birth') {
              // age_year_of_birth is submitted as an age
              data.numericAnswer = moment().get('year') - value.number
            } else {
              data.numericAnswer = value.number
            }
          }
          break
        case Types.CONSTANT_SUM:
          if (self.matrixEnabled) {
            _.each(self.statementAnswers, function(choices, statementId) {
              var statement = _.find(self.statements, { id: statementId })
              _.each(choices, function(choice) {
                data.statementAnswers.push({
                  id: statementId,
                  statement: statement.statement,
                  optionId: choice.id,
                  option: choice.option,
                  number: choice.numberValue,
                })
              })
            })
          } else {
            data.choiceAnswers = _.map(self.selected, function(item) {
              return {
                id: item.id,
                option: item.option,
                number: item.numberValue,
              }
            })
          }
          break
        case Types.SCORE:
          // this block is very similar to constant-sum above
          // with exception of not having `number: choice.numberValue`
          if (self.matrixEnabled) {
            _.each(self.statementAnswers, function(choices, statementId) {
              var statement = _.find(self.statements, { id: statementId })
              _.each(choices, function(choice) {
                data.statementAnswers.push({
                  id: statementId,
                  statement: statement.statement,
                  optionId: choice.id,
                  option: choice.option,
                })
              })
            })
          } else {
            var choice = self.selected[0]
            if (choice) {
              data.choiceAnswers = [
                {
                  id: choice.id,
                  option: choice.option,
                },
              ]
            }
          }
          break
        case Types.HIDDEN_VARIABLES:
          // submit all visible variables as answers
          data.choiceAnswers = _.map(visibleChoices, function(item) {
            return {
              id: item.id,
              option: item.option,
            }
          })
          break
      }

      return data
    }

    ResponderQuestion.prototype.applyPersistedBorrowedOrder = function() {
      // If this question borrows options from a previous question
      // and has the "persist" option enabled, we will update the order of these
      // options to match the question we're borrowing from.
      // IMPORTANT: This should run after all questions have had any randomizations
      // applied.
      var self = this

      function apply(initial, target) {
        // initial: the options we want to re-order
        // target: the options we want to copy the order of
        //
        // var logTarget = _.map(target, 'label')
        // var logInitial = _.map(initial, 'label')
        var final = _.orderBy(initial, function(option) {
          // We use the index of the matching option in the lender
          // as the order number to re-order these options by.
          var idx = target.findIndex(function(tOption) {
            return tOption.id === option.id
          })
          // If the option can't be found it's (most likely?) an option
          // added on top of the borrowed options.
          // In this case we'll use the order number 9999 to make sure
          // it gets added at the end.
          // Lodash's orderBy() keeps items with the same order number
          // in the same order as the original.
          return idx === -1 ? 9999 : idx
        })
        // var logFinal = _.map(final, 'label')
        // console.table({
        //   initial: logInitial,
        //   target: logTarget,
        //   final: logFinal,
        // })
        return final
      }

      if (this.choiceLender.id && this.choiceLender.persistOrder) {
        var lender = _.find(self.responder.questions, {
          id: this.choiceLender.id,
        })
        var target = this.choiceLender.targetsStatements()
          ? lender.statements
          : lender.choices
        self.choices = apply(self.choices, target)
      }

      if (this.statementLender.id && this.statementLender.persistOrder) {
        var lender = _.find(self.responder.questions, {
          id: this.statementLender.id,
        })
        var target = this.statementLender.targetsStatements()
          ? lender.statements
          : lender.choices
        self.statements = apply(self.statements, target)
      }
    }

    ResponderQuestion.prototype.recalculateRanks = function() {
      var self = this
      var rank = 0

      // ensure there are no gaps in ranks
      _.forEach(_.sortBy(self.selected, 'rank'), function(item) {
        item.rank = rank++
      })
    }

    /**
     * @name Is Answered
     * @desc determine if the question is answered
     * @returns {Boolean} answered - Whether the question is answered
     */
    ResponderQuestion.prototype.isAnswered = function() {
      var self = this

      if (!self.isValidAnswer()) return false

      switch (self.type) {
        case Types.IMAGE:
          return !!(self.imageData || self.image)
        case Types.TEXT:
          var texts = self.getValidTexts()
          return self.isCompulsory
            ? texts.length >= self.minAnswers
            : texts.length
        case Types.TEXTAREA:
        case Types.SCAN:
        case Types.LOCATION:
          return !!self.text
        case Types.NPS:
        case Types.MOOD:
        case Types.CHOICE:
        case Types.RANK:
        case Types.PLACE:
        case Types.SCALE:
        case Types.SEX:
        case Types.AGE_RANGE:
        case Types.RATING:
        case Types.NUMERIC:
          if (self.minSelections === -1) {
            var exclusiveSelected = _.some(self.selected, function(selection) {
              return selection.data && selection.data.isExclusive
            })
            var hasReachMaxSelections =
              self.selected.length === self.maxSelections
            // -1 means they have to select ALL visible choices.
            // this is useful for Rank when you want the respondent to rank all choices
            return (
              self.selected.length === self.getVisibleChoices().length ||
              exclusiveSelected ||
              hasReachMaxSelections
            )
          }
          if (self.minSelections > 0) {
            var exclusiveSelected = _.some(self.selected, function(selection) {
              return selection.data && selection.data.isExclusive
            })
            return (
              self.selected.length >= self.minSelections || exclusiveSelected
            )
          }
          return self.selected.length > 0
        case Types.MATRIX:
          // compulsory: all statements answered
          if (self.isCompulsory) {
            var answered = true
            var statements = self.getVisibleStatements()
            _.each(statements, function(statement) {
              var selected = self.statementAnswers[statement.id]
              if (!selected || !selected.length) {
                answered = false
                return false
              }
            })
            return statements.length > 0 ? answered : false
          }
          // optional: atleast one statement answered
          return _.some(_.values(self.statementAnswers), function(answers) {
            return answers.length
          })
        case Types.FOLLOWUP:
          var requested = !!self.selected.length
          if (requested && !self.isLoggedIn && !self.email) {
            return false
          }
          return true
        case Types.CONSTANT_SUM:
        case Types.SCORE:
          if (self.matrixEnabled) {
            if (self.isCompulsory) {
              return _.every(self.getVisibleStatements(), function(statement) {
                return self.statementAnswers[statement.id].length > 0
              })
            }
            // optional: atleast one statement answered
            return _.some(self.statementAnswers, function(choices) {
              return choices.length > 0
            })
          } else {
            return self.selected.length > 0
          }
        case Types.HIDDEN_VARIABLES:
          // HIDDEN VARIABLES is not shown to respondent, but for validation purposes,
          // it will always considered as 'answered' to allow respondent continue to
          // next questions and allow the displayed variables to be submitted as response
          return true
        default:
          throw new Error('unknown question type: ' + self.type)
      }
    }

    ResponderQuestion.prototype.getAnswerText = function(
      num,
      statementNumber,
      onlyTextEntry,
      onlyNumberEntry,
      onlySumEntry
    ) {
      var self = this
      var value

      // At some point we will support multiple text answers per choice question and
      // this will need to be updated to work with the `num` parameter for onlyTextEntry

      switch (self.type) {
        case Types.TEXT:
          if (onlySumEntry) break // unsupported...
          var values = self.getValidTexts()
          if (onlyNumberEntry) {
            if (!_.includes(['NUMERIC', 'NUMERIC_RANGE'], self.textValidator))
              break // only support numeric validator text question
            if (_.isNumber(num)) {
              // coerce to number
              value = +values[num - 1]
            } else {
              value = +values[0] // default to first entry
            }
          } else {
            if (_.isNumber(num)) {
              value = values[num - 1]
            } else {
              value = values.join(', ')
            }
          }
          break
        case Types.TEXTAREA:
        case Types.SCAN:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...
          value = self.text
          break
        case Types.LOCATION:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...
          var slot = locationSetService.getInfoByType(
            locationSetService.Type.NAME
          ).slot
          value = self.text && self.text.split('|')[slot]
          break
        case Types.NPS:
        case Types.CHOICE:
        case Types.RANK:
        case Types.SEX:
        case Types.AGE_RANGE:
        case Types.SCALE:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...
          if (onlyTextEntry) {
            if (!_.isNumber(num)) break // invalid number
            // when onlyTextEntry, get the value from selected text capture choice
            // based on `num` value in visible choices
            var captureChoices = _.filter(self.getVisibleChoices(), function(
              choice
            ) {
              return choice.data.isCapture
            })
            var captureChoice = captureChoices[num - 1] // num:1 === index:0
            var isSelected = captureChoice && self.isSelected(captureChoice)
            value = isSelected ? captureChoice.textCaptureValue : null
          } else {
            var items = _(self.selected)
              .map(function(selected) {
                return {
                  value: selected.option,
                  rank: selected.rank,
                }
              })
              .orderBy('rank', 'asc')
              .map('value')
              .value()
            if (items.length) {
              if (_.isNumber(num)) {
                value = items[num - 1] // num:1 === index:0
              } else {
                value = items.join(', ')
              }
            }
          }
          break
        case Types.CONSTANT_SUM:
          if (onlySumEntry) {
            if (self.matrixEnabled) {
              // FOR THIS ONLY SUM ENTRY USE CASE, we must break consistency
              // normally statementNumber refer to the order of visible statements,
              // for this use case, we must refer to original statements that
              // was not randomised or shuffled
              var serverStatements = _.filter(
                self.serverData.statements,
                function(statement) {
                  // remove hidden statements
                  return !(statement.data && statement.data.isHidden)
                }
              )
              var visibleStatements = self.getVisibleStatements()
              // if `statementNumber` exist, then use it as index,
              // otherwise default to first statement with selected choices
              var statement = _.isNumber(statementNumber)
                ? serverStatements[statementNumber - 1]
                : _.find(visibleStatements, function(statement) {
                    return self.statementAnswers[statement.id].length > 0
                  })
              // Only return a total if the found statement is actually in the visible set.
              statement =
                statement && _.find(visibleStatements, { id: statement.id })
              value = statement
                ? self.getSelectedTotalNumber(statement) + '' // coerce to text
                : ''
            } else {
              value = self.getSelectedTotalNumber() + '' // coerce to text
            }
            break
          }

          var selected = []
          if (self.matrixEnabled) {
            var statements = self.getVisibleStatements()
            if (!statements.length) break // no visible statements
            var statement = null
            if (_.isNumber(statementNumber)) {
              // if `statementNumber` exist, then `num` must be exist
              // and is a selection number for choice
              statement = statements[statementNumber - 1]
              selected = statement ? self.statementAnswers[statement.id] : []
            } else if (_.isNumber(num)) {
              // if `statementNumber` undefined, then use `num` as the statement number
              statement = statements[num - 1]
              selected = statement ? self.statementAnswers[statement.id] : []
              num = null // set to null so it won't be used on the code below for selection
            } else {
              // if `statementNumber` and `num` undefined, then
              // default to first statement with selected choices
              statement = _.find(statements, function(statement) {
                return self.statementAnswers[statement.id].length > 0
              })
              selected = statement ? self.statementAnswers[statement.id] : []
            }
          } else {
            selected = self.selected
          }

          var items = _.map(self.getVisibleChoices(), function(choice) {
            var selectedChoice = _.find(selected, { id: choice.id })
            if (onlyNumberEntry) {
              return selectedChoice ? selectedChoice.numberValue + '' : null // coerce to text
            } else {
              return selectedChoice ? selectedChoice.option : null
            }
          })

          if (!items.length) break // no visible choices

          if (_.isNumber(num)) {
            value = items[num - 1]
          } else {
            value = _.compact(items).join(', ')
          }
          break
        case Types.NUMERIC:
          if (onlySumEntry) break // unsupported...
          if (onlyNumberEntry) {
            value = self.selected[0] ? self.selected[0].number : null
          } else {
            value = self.selected[0] ? self.selected[0].label : ''
          }
          break
        case Types.RATING:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...
          value = self.selected[0]
            ? self.selected[0].label +
              (self.selected[0].numericOption > 1 ? ' stars' : ' star')
            : ''
          break
        case Types.MOOD:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...
          value = self.selected[0].label
          break
        case Types.PLACE:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...
          var place = self.selected[0]
          value = place.name || place.title
          break
        case Types.IMAGE:
        case Types.FOLLOWUP:
          // unsupported...
          break
        case Types.MATRIX:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...

          var items = _.map(self.getVisibleStatements(), function(statement) {
            return _.map(self.statementAnswers[statement.id], function(choice) {
              return {
                option: choice.option,
                text: choice.data.isCapture
                  ? self.statementTextCaptureValues[statement.id][choice.id]
                  : '',
              }
            })
          })

          if (!items.length) break // no visible statements

          if (_.isNumber(statementNumber)) {
            // if `statementNumber` exist, then `num` must be exist and
            // is a selection number for choice
            var item = items[statementNumber - 1][num - 1]
            value = item ? (onlyTextEntry ? item.text : item.option) : null
          } else if (_.isNumber(num)) {
            // if `statementNumber` undefined, then use `num` as the statement number
            value = _(items[num - 1])
              .map(onlyTextEntry ? 'text' : 'option')
              .compact() // remove falsey values eg 0, '', null, undefined
              .value()
              .join(', ')
          } else {
            // if `statementNumber` and `num` undefined, then
            // default to first statement with selected choices
            // there's no way onlyTextEntry is possible here because there's no identifier (no statementNumber and no num)
            var statement = _.find(items, function(selected) {
              return selected.length > 0
            })
            // onlyTextEntry is always false in this else block because
            // there's no pipes directive eg `statementNumber` or `num`
            // so we always map with `option`
            value = statement ? _.map(statement, 'option').join(', ') : ''
          }
          break
        case Types.SCORE:
          if (onlyNumberEntry || onlySumEntry) break // unsupported...

          if (self.matrixEnabled) {
            var items = _.map(self.getVisibleStatements(), function(statement) {
              return _.map(self.statementAnswers[statement.id], 'option')
            })

            if (!items.length) break // no visible statements

            if (_.isNumber(statementNumber) || _.isNumber(num)) {
              // if `statementNumber` exist, then ignore `num` because score is single select
              // if `statementNumber` undefined, then use `num` as the statement number
              var index = (statementNumber || num) - 1
              value = items[index][0]
            } else {
              // if `statementNumber` and `num` undefined, then
              // default to first statement with selected choice
              var statement = _.find(items, function(selected) {
                return selected.length > 0
              })
              value = statement ? statement[0] : ''
            }
          } else {
            // score is always single select
            value = self.selected[0] ? self.selected[0].option : ''
          }
          break
        case Types.HIDDEN_VARIABLES:
          if (onlyNumberEntry || onlyTextEntry || onlySumEntry) break // unsupported...

          var items = _.map(self.getVisibleChoices(), 'option')
          if (items.length) {
            if (_.isNumber(num)) {
              value = items[num - 1] // num:1 === index:0
            } else {
              value = items.join(', ')
            }
          }
          break
      }

      return value || ''
    }

    ResponderQuestion.prototype.getValidTexts = function() {
      return _.without(this.texts, '', null, undefined)
    }

    ResponderQuestion.prototype.getInjectedTitle = function() {
      return this.responder.injectValues(this.titlePipes, this.loopKey)
    }

    /**
     * Reset
     * @desc resets the question using the original server data
     */
    ResponderQuestion.prototype.reset = function() {
      this.fromServer(this.serverData)
    }

    /**
     * Autocomplete
     * @desc autocompletes a question based on the storage method
     * @param {UserStorage|TransientStorage} storage - the storage instance to use
     */
    ResponderQuestion.prototype.autocomplete = function(storage) {
      var self = this

      // stop if this question isn't autocompletable
      if (!self.autocompleteKey) {
        log.debug('autocomplete skipped (no autocompleteKey)')
        return
      }

      if (!storage) {
        log.debug('autocomplete reset (no storage)')
        return self.reset()
      }

      // fetch the stored autocomplete (if any)
      var key = self.autocompleteKey
      var autocomplete = storage.get(key)

      // reset if nothing to autocomplete with, and stop
      if (!autocomplete) {
        log.debug('autocomplete reset (no autocomplete found)')
        return self.reset()
      }

      // begin to autocomplete the question
      // make sure choices exist and they aren't hidden

      var isInvalid
      var data = {}
      data.selected = []
      data.statementAnswers = {}
      data.text = autocomplete.text
      data.email = autocomplete.email
      data.fullname = autocomplete.fullname
      data.image = autocomplete.image

      _.each(autocomplete.selected, function(selection) {
        // Instead of doing `this.selected = autocomplete.selected`, we must find the real
        // choice from the survey to maintain the reference. This is because the isSelected() method
        // compares references, not values.
        //
        // DEBT: We match choices by option text (or label/name etc) instead of id because the backend does not retain id's
        // across template inclusions. This leaves a few edge cases that can screw with data so we should
        // move away from this at some point.
        var predicate
        switch (self.type) {
          case Types.NPS:
          case Types.CHOICE:
          case Types.FOLLOWUP:
          case Types.MOOD:
          case Types.RATING:
          case Types.SEX:
          case Types.AGE_RANGE:
            predicate = { option: selection.option }
            break
          case Types.NUMERIC:
            predicate = { number: selection.number }
            break
          case Types.PLACE:
            predicate = function(choice) {
              return (
                choice.name === selection.name ||
                choice.title === selection.title
              )
            }
            break
        }
        var choice = _.find(self.choices, predicate)

        // we also do this^ to determine if the choice even exists. If it doesn't it is probably hidden, and
        // we want identities to be asked the question again to get updated information
        if (!choice) {
          isInvalid = true
          return false
        }

        data.selected.push(choice)
      })

      _.each(autocomplete.statementAnswers, function(choiceId, statementId) {
        // The survey may have changed so we ensure the statement and choice still exists
        var statement = _.find(self.statements, { id: statementId })
        var choice = _.find(self.choices, { id: choiceId })
        if (!statement || !choice) {
          isInvalid = true
          return false
        }
        data.statementAnswers[statementId] = choiceId
      })

      // abort if invalid, we want the identity to answer this question again
      if (isInvalid) {
        return
      }

      log.debug(
        'autocomplete found for autocompleteKey:' +
          self.autocompleteKey +
          ' identity:' +
          storage.identity
      )

      // update the answer using the autocomplete
      _.assign(self, data)

      // remember the identity this was autocompleted with
      self.autocompletedByIdentity = storage.identity
    }

    /**
     * Store Autocomplete
     * @desc stores the answers to this question as an autocomplete based on the storage method
     * @param {Object} storage - the storage method to use: user or transient storage
     */
    ResponderQuestion.prototype.storeAutocomplete = function(storage) {
      var self = this

      if (!self.autocompleteKey) {
        return
      }

      // don't store if the user didn't answer the question
      if (!self.isAnswered()) {
        log.debug(
          'autocomplete not storing: ' +
            self.autocompleteKey +
            ' (identity did not answer)'
        )
        return
      }

      var autocomplete = self.toAutocomplete()
      storage.update(self.autocompleteKey, autocomplete)
    }

    /**
     * To Autocomplete
     * @desc
     */
    ResponderQuestion.prototype.toAutocomplete = function() {
      return {
        selected: angular.copy(this.selected), // angular.copy removes $$hashKey + immutable
        statementAnswers: _.mapValues(this.statementAnswers, 'id'),
        text: this.text,
        email: this.email,
        fullname: this.fullname,
        image: this.image,
      }
    }

    return ResponderQuestion
  }
})()
